import { useCallback } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { createClerkSupabaseClient } from '../utils/supabase';

/**
 * Her çağrıda taze bir Clerk JWT alıp kimlikli bir Supabase client döndürür.
 *
 * Token alma sırası:
 *   1. `template: 'supabase'` ile dene (Clerk Dashboard'da JWT template tanımlıysa)
 *   2. Yoksa (null dönerse) template'siz varsayılan Clerk token'ı kullan
 *      (Clerk'in native Third-Party Auth / Supabase entegrasyonu bu şekilde çalışır)
 */
export function useSupabaseClient() {
  const { getToken } = useAuth();
  return useCallback(async () => {
    // Önce özel template dene
    let token: string | null = null;
    try {
      token = await getToken({ template: 'supabase' });
    } catch {
      token = null;
    }

    // Template yoksa veya null döndüyse: varsayılan Clerk JWT
    if (!token) {
      try {
        token = await getToken();
      } catch {
        token = null;
      }
    }

    if (!token) throw new Error('Kimlik doğrulama tokeni alınamadı. Lütfen sayfayı yenileyin.');
    return createClerkSupabaseClient(token);
  }, [getToken]);
}
